import { createContext } from 'react';
export const FirebasePerformanceContext = createContext({
    initTracker: () => undefined,
    recordPerformance: () => undefined,
});
